export default {
    appNewView: '/gateway/manageBedrock/free/newscs/appNewView', // 新闻详情
}


// WEBPACK FOOTER //
// ./src/find/detail/api.js